module.exports = __webpack_public_path__ + "static/media/close.f4127581.svg";